import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';
import React from 'react';
import * as ds from './dataService';


export type MarkInstallationAsInstalledModalProps = {
  id: string;
  isVisible: boolean;
  isComplete: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MarkInstallationAsInstalledModalProps) => {

  const [
    fnSaveInstallation,
    { loading }
  ] = ds.useSaveInstallation(props.isComplete);

  return (
    <InformationModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      loading={loading}
      handleClose={() => props.handleClose()}
      title={`Mark as ${props.isComplete ? 'not Installed' : 'Installed'}`}
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELETE'
        />
      )}
      successButton={{
        text: 'Confirm',
        handleClick: async () => {
          await fnSaveInstallation(props.id);
          props.handleClose();

        }
      }}
      cancelButton={{
        text: 'Cancel',
        handleClick: () => props.handleClose()
      }}
    />
  );
};
